export default __webpack_public_path__ + "static/media/news1.26309269.jpg";